function NavigationBar() {
    return null;
}
NavigationBar.displayName = 'NavigationBar';

export default NavigationBar;
